export enum PurchaseRequestDocumentUploadDialogAction {
  BACK = 'back',
  SUCCESS = 'success'
}

export interface PurchaseRequestDocumentUploadDialogResult {
  action: PurchaseRequestDocumentUploadDialogAction;
}
